// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__iboLO","list":"PatternAutocomplete_list__3iqxo"};